import { useEffect } from 'react';
import { startAutomaticUpdates } from '../lib/automaticUpdates';

export default function AutomaticUpdates() {
  useEffect(() => {
    if (['localhost', '127.0.0.1'].includes(window.location.hostname)) return undefined;
    return startAutomaticUpdates();
  }, []);
  return null;
}
